// extracted by mini-css-extract-plugin
module.exports = {"link":"ViewPriceDetails-module__link___9z0Nn"};